import { IVideoInternalAsset } from '../../../modules/videos/types'
import style from './style.module.scss'
import commonStyle from '../style.module.scss'
import useViewport from '../../../modules/viewport/useViewport'
import useInterfaceLocale from '../../../modules/locale/useInterfaceLocale'
import VideoInternalView from '../../Video/InternalVideo'
import { QuestionType } from '../../types'
import { IVideoInternalQuestionSchema } from '../../Video/types'
import { Button } from 'primereact/button'
import { useRef, useState } from 'react'
import useTimeline from '../../../modules/timeline/useTimeline'

interface IVideoInternalAssetWithWatched extends IVideoInternalAsset {
  watched: boolean
}
export interface VideoBlockProps {
  videos?: IVideoInternalAsset[]
  media_mask?: string[]
  id: string
  showValidationError?: boolean
  valid?: boolean
  onWatched?: () => void
}

export default function VideoBlock({ videos, media_mask, id, showValidationError, onWatched }: VideoBlockProps) {
  const viewport = useViewport()
  const { t } = useInterfaceLocale()
  const timeline = useTimeline()
  const localVideos = useRef<IVideoInternalAssetWithWatched[]>([])
  if (!localVideos.current.length && videos && media_mask) {
    localVideos.current = media_mask.reduce((acc: IVideoInternalAssetWithWatched[], uid) => {
      const video = videos.find(video => video.uid === uid)
      if (video) {
        acc.push({ ...video, watched: false })
      }
      return acc
    }, [])
    localVideos.current.forEach((video, index) => {
      timeline.log({
        type: 'video_ordered',
        ref: id,
        target: video.uid,
        context: {
          index: index
        }
      })
    })
  }

  const [activeVideo, setActiveVideo] = useState<number>(0)

  const schemas: IVideoInternalQuestionSchema[] = localVideos.current.map(video => {
    return {
      video: video,
      type: QuestionType.VIDEO,
      min_duration: 0,
      id,
      text: '',
      position: 0,
      allow_replay: true,
      video_type: 'file',
      time: 0
    }
  })
  if (!localVideos.current.length) return null

  const onVideoViewed = (uid?: string) => {
    if (uid && uid === localVideos.current[activeVideo].uid) {
      timeline.log({
        type: 'video_viewed',
        ref: id,
        target: localVideos.current[activeVideo].uid
      })
      localVideos.current[activeVideo].watched = true
      if (localVideos.current.every(video => video.watched)) {
        timeline.log({
          type: 'all_videos_watched',
          ref: id
        })
        onWatched()
      }
    }
  }

  return (
    <div
      className={`${style.videoBlock} ${viewport.mobile ? style.mobile : ''}`}
      data-testid="SW-Question-Video-Embedding"
    >
      <legend
        className={`${commonStyle.validationMessage}${showValidationError ? ' ' + commonStyle.error : ''}`}
        data-testid="SW-MX-ValidationMessage"
      >
        <span
          dangerouslySetInnerHTML={{
            __html:
              localVideos.current.length > 1 ? t('questions', 'videos', 'notes') : t('questions', 'videos', 'note')
          }}
        />
      </legend>
      {schemas.map((schema, index) => (
        <div key={index} style={{ display: index === activeVideo ? 'block' : 'none' }} className={style.videoBlockItem}>
          <VideoInternalView schema={schema} onVideoViewed={onVideoViewed} stopped={index !== activeVideo} />
        </div>
      ))}

      {localVideos.current.length > 1 && (
        <div className={style.buttons}>
          <Button
            label={t('questions', 'videos', '0')}
            onClick={() => setActiveVideo(0)}
            disabled={0 === activeVideo}
            icon={'pi pi-chevron-left'}
            iconPos="left"
          />
          <span className={style.videoNumber}>
            {t('questions', 'videos', 'video')} {activeVideo + 1} / {localVideos.current.length}
          </span>
          <Button
            label={t('questions', 'videos', '1')}
            onClick={() => setActiveVideo(1)}
            disabled={1 === activeVideo}
            icon={'pi pi-chevron-right'}
            iconPos="right"
          />
        </div>
      )}
    </div>
  )
}
